import styled from 'styled-components';

export const LoginContainer = styled.div`
height: 100vh;
min-height: 800px;
`;

export const LoginWrapper = styled.div`
display: grid;
height: 100%;
grid-template-columns: 1fr 1fr;

@media screen and (max-width: 900px){
    grid-template-columns: 1fr;
}
`;

export const LoginSectionLeft = styled.div`
display: flex;
flex-direction: column;
height: 100%;
justify-content: center;
align-items: center;
background: linear-gradient(to bottom, #619657, #588d4f, #4f8446, #477c3e, #3e7336, #376c2f, #2f6429, #285d22, #1f551a, #154d12, #0a450a, #003d01);
box-shadow: 5px 5px 20px 10px rgba(0,0,0,0.3);

@media screen and (max-width: 900px){
    display: none;
}
`;

export const LoginSectionRight = styled.div`
display: flex;
flex-direction: column;
height: 100%;
justify-content: center;
align-items: center;
`;

export const LoginForm = styled.form`
display: flex;
flex-direction: column;
`;

export const LoginLabel = styled.label`
color: #000;
`;

export const LoginInput = styled.input`
border: none;
border-bottom: 2px solid #D3D3D3;
height: 30px;
width: 400px;
padding-left: 5px;
margin-bottom: 40px;
transition: all 0.2s ease-in-out;

&:focus {
    outline: none;
    border-bottom: 2px solid #33682c;
}

@media screen and (max-width: 768px){
    width: 350px;
}

@media screen and (max-width: 480px){
    width: 300px;
}
`;

export const LoginButton = styled.button`
width: 100%;
height: 50px;
border-radius: 5px;
border: none;
background: rgb(51,104,44);
background: linear-gradient(215deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
color: #fff;
font-weight: bold;
margin-top: 25px;
margin-left: auto;
margin-right: auto;

&:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.05);
    background: linear-gradient(45deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
    cursor: pointer;
}
`;

export const TextWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
`;

export const LogoImage = styled.img`
width: 100%;
max-width: 600px;
height: auto;
margin-left: auto;
margin-right: auto;
padding-right: 50px;
padding-left: 50px;
`;

export const FormHeader = styled.h1`
font-size: 28px;
color: #33682c;
margin-bottom: 50px;
`;

export const Checkbox = styled.input`
width: 15px;
height: 15px;
accent-color: #33682c;

&:hover{
    cursor: pointer;
}
`;

export const Remembertext = styled.p`
font-size: 14px;
color: #808080;
margin-left: 10px;
`;

export const RememberWrapper = styled.div`
display: flex;
flex-direction: row;
`;

export const Forgottext = styled.a`
font-size: 14px;
font-weight: bold;
color: #33682c;
text-decoration: none;

&:hover {
    cursor: pointer;
}
`;

export const MobileLogo = styled.img`
width: 100%;
max-width: 200px;
height: auto;
position: absolute;
top: 5vh;
display: none;

@media screen and (max-width: 900px){
    display: block;
}
`;

export const SignUpWrapper = styled.div`
display: flex;
flex-direction: row;
margin-top: 50px;
margin-left: auto;
margin-right: auto;
`;

export const SignUptext = styled.p`
font-size: 14px;
color: #808080;
`;

export const SignUpTextLink = styled.a`
font-size: 14px;
font-weight: bold;
color: #33682c;
text-decoration: none;

&:hover {
    cursor: pointer;
}
`;

export const LoginDescWrapper = styled.div`
display: flex;
flex-direction: column;
margin-top: 100px;
text-align: center;
`;

export const LoginHeader = styled.p`
font-size: 24px;
color: #fff;
`;

export const LoginDesc = styled.p`
font-size: 16px;
color: #fff;
margin-top: 10px;
`;

export const FeedbackText = styled.p`
font-size: 14px;
color: #000;
text-align: center;
margin-top: 25px;
`;
